import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { getDynamicNavigationItems } from '../components/common/Sidebar/NavigationItems';

export const useBreadcrumbs = () => {
  const { role } = useAuth();
  const location = useLocation();

  // Get the navigation items the user is allowed to see
  const accessibleNavItems = useMemo(() => getDynamicNavigationItems(role), [role]);

  // Generate breadcrumbs based on the current path
  const breadcrumbs = useMemo(() => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    let crumbs = [{ label: 'Dashboard', path: '/dashboard' }];

    pathnames.reduce((accPath, currentPath) => {
      const newPath = `${accPath}/${currentPath}`;
      // Find a matching navigation item for the current path segment
      const navItem = accessibleNavItems.find(item => item.path === newPath);

      // Add the crumb if it's a recognized navigation item
      if (navItem) {
        crumbs.push({ label: navItem.label, path: newPath });
      }
      return newPath;
    }, '');

    // Prevent duplicate "Dashboard" crumb if on the dashboard page
    if (location.pathname === '/dashboard') {
        return [{ label: 'Dashboard', path: '/dashboard' }];
    }
    
    return crumbs;
  }, [location.pathname, accessibleNavItems]);

  return breadcrumbs;
};